import type { ExtractFilterValue, FiltersMap } from '@wix/bex-core';
import { CursorFetchDataFn, OffsetFetchDataFn } from '@wix/bex-core/react';
import { UsePickerModalParamsBase } from './UsePickerModalParamsBase';

export type RawFiltersParams<F extends FiltersMap> = {
  [P in keyof F]: {
    initialValue?: ExtractFilterValue<F[P]>;
  };
};

export interface PickerModalEvents {
  readonly onError?: (params: {
    err: unknown;
    isOnline: boolean;
  }) => boolean | null | undefined | void;
}

type PaginationModeConfig<T, F extends FiltersMap> =
  | {
      paginationMode?: 'offset';
      fetchData: OffsetFetchDataFn<T, F>;
    }
  | {
      paginationMode: 'cursor';
      fetchData: CursorFetchDataFn<T, F>;
    };

export type UsePickerModalParams<T, F extends FiltersMap> = Omit<
  UsePickerModalParamsBase<T, F>,
  'paginationMode' | 'fetchData'
> &
  PaginationModeConfig<T, F>;
